





































































import Vue from 'vue';
import { mapState } from 'vuex';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import LinkVariantIcon from 'vue-material-design-icons/LinkVariant.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxTooltip from '@/dex-shared/components/px-tooltip.vue';
import Pagination from '@/components/Pagination.vue';
import Header from '@/components/Header.vue';
import Loading from '@/dex-shared/components/Loading.vue';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
    pxTooltip,
    Pagination,
    Loading,
    ArrowRightIcon,
    TrashCanOutlineIcon,
    LinkVariantIcon,
    Header,
  },

  data() {
    return {
      openedExamGroupTooltipIndex: -1,
      currentPage: 0,
      loaded: true,
    };
  },

  computed: {
    ...mapState({
      exams: (state: any) => state.exams.exams,
    }),
  },

  async mounted() {
    let page = parseInt(this.$route.params.page);
    if (page > 0) {
      this.currentPage = page - 1;
    } else {
      this.$router.replace(`/provas`);
    }
    this.loaded = false;
    await this.$store.dispatch('PULL_EXAMS', this.currentPage);
    this.loaded = true;
  },

  methods: {
    removeExam: async function(examId: number, index: number) {
      if (
        confirm(
          'Tem certeza que deseja deletar essa prova? Ela não poderá ser recuperada!',
        )
      ) {
        let response = await this.$store.dispatch('REMOVE_EXAM', examId);

        if (response === true) {
          this.$store.commit('REMOVE_EXAM', index);
        } else {
          //TODO analyze the error
          alert('Essa prova não pode ser deletada pois está em um simulado!');
        }
      }
    },

    openExamGroupTooltip: function(index: number) {
      if (index == this.openedExamGroupTooltipIndex) {
        this.openedExamGroupTooltipIndex = -1;
      } else {
        this.openedExamGroupTooltipIndex = index;
      }
    },

    changePage: async function(event: any) {
      this.currentPage = event;
      await this.$store.dispatch('PULL_EXAMS', this.currentPage);
      this.$router.push(`/provas/${this.currentPage + 1}`);
    },
  },
});
